import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewportSwitcher = ({ currentViewport, onViewportChange }) => {
  const viewports = [
    { id: 'desktop', name: 'Десктоп', icon: 'Monitor', width: '100%' },
    { id: 'tablet', name: 'Планшет', icon: 'Tablet', width: '768px' },
    { id: 'mobile', name: 'Мобильный', icon: 'Smartphone', width: '375px' }
  ];

  return (
    <div className="flex items-center gap-2 p-2 bg-card border border-border rounded-lg">
      {viewports?.map(viewport => (
        <button
          key={viewport?.id}
          onClick={() => onViewportChange(viewport?.id)}
          className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
            currentViewport === viewport?.id
              ? 'bg-primary text-primary-foreground'
              : 'hover:bg-muted text-foreground'
          }`}
          aria-label={`Переключить на ${viewport?.name}`}
        >
          <Icon name={viewport?.icon} size={18} />
          <span className="hidden sm:inline text-sm font-medium">{viewport?.name}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewportSwitcher;